import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class StatusCentroCusto extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/StatusCentroCustoLookup" {...this.props} />;
  }
}

export default StatusCentroCusto;
